export * from './LazyHCaptcha';
